import React, { useEffect, useState } from "react";
import moment from "moment";
import { URLS } from "../../urls";
import { Helmet } from "react-helmet";
import Topbar from "../user-topbar/UserTopbar";
import Sidebar from "../user-sidebar/UserSidebar";
import RsDateRangePicker from "../../RsDateRangePicker.jsx";
import {
  arrangeEventObject,
  fetchActionsUtil,
  statusColor,
  stringifyQueryString,
  useCookie,
} from "../../../utils.js";
import ModalLoader from "../../ModalLoader";
import { UseQueryData } from "../../UseQueryData.jsx";
import CustomPagination from "../../Paginations.jsx";
import { CalendarTodayOutlined } from "@mui/icons-material";
import { DownArrowIcon, GridIcon, ListIcon } from "../../icons.js";
import TableComponent from "../../TableComponent.js";
import NoTableItem from "../../NoTableItem.jsx";
import CalendarView from "../../permission/CalenderView.jsx";

const Holidays = () => {
  const branch_id = useCookie("branch_id");

  // ------------------ Filter Search -------------------//
  const initialQueryParams = {
    limit: 20,
    page: 1,
    status: "",
    endDate: "",
    startDate: "",
  };
  const { queryParams, theQueryParams, onChangeInput, setQueryParams } =
    UseQueryData({
      initialQueryParams,
      timer: 1500,
    });
  // ------------------ Filter Search -------------------//

  const [returnParams, setReturnParams] = useState({
    count: 0,
    endIndex: 0,
    startIndex: 0,
  });

  const [loading, setLoading] = useState(false);

  const [allPermission, setAllPermission] = useState([]);
  const [openDetails, setOpenDetails] = useState({});
  const [changeView, setChangeView] = useState("table");

  const fetchData = async () => {
    try {
      setLoading(true);

      const permissionData = fetchActionsUtil(
        `${
          URLS.backendpermmission
        }/by-branch/${branch_id}?${stringifyQueryString(
          queryParams
        )}&activeTab=holiday`
      );

      const [permissionResult] = await Promise.all([permissionData]);

      setAllPermission(permissionResult?.permission);
      setOpenDetails({
        uniqueStatus: permissionResult?.uniqueStatus,
        uniqueNames: permissionResult?.uniqueNames,
      });
      setReturnParams({
        count: permissionResult?.count,
        endIndex: permissionResult?.endIndex,
        startIndex: permissionResult?.startIndex,
      });
    } catch (error) {
      console.log({ error });
    } finally {
      setLoading(false);
    }
  };

  const filterByDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: picker.startDate.add(1, "hours"),
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: picker.endDate,
      })
    );

    picker.element.val(
      picker.startDate.format("YYYY-MM-DD") +
        " - " +
        picker.endDate.format("YYYY-MM-DD")
    );
  };

  const clearDateRange = (event, picker) => {
    onChangeInput(
      arrangeEventObject({
        name: "endDate",
        value: "",
      })
    );

    onChangeInput(
      arrangeEventObject({
        name: "startDate",
        value: "",
      })
    );

    picker.element.val("");
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchData();
    }

    return () => {
      isMounted = false;
    };
  }, [queryParams]);

  const dropDownFunction = (qty) => {
    setQueryParams((el) => ({ ...el, limit: qty }));
  };

  const permissionTableHead = () => {
    return (
      <thead className="table">
        <tr>
          <th className="text-center">S/N</th>
          <th className="text-center">Holiday Name</th>
          <th>Status</th>
          <th>Reoccurrence</th>
          <th>Date</th>
          <th className="text-center">Description</th>
        </tr>
      </thead>
    );
  };

  const permissionTableBodyData = (permit, index) => {
    return (
      <>
        <td>{index + 1}</td>

        <td className="text-center">{permit?.holidayName}</td>
        <td className="text-center fw-bold">
          <p
            className={`tw-status ${statusColor(
              permit.status === "Approved"
                ? "green"
                : permit.status === "Pending"
                ? "orange"
                : "red"
            )}`}
          >
            {permit.status}
          </p>
        </td>
        <td className="text-center fw-bold">
          <p
            className={`tw-status ${statusColor(
              permit.reoccurring ? "green" : "red"
            )}`}
          >
            {permit.reoccurring ? "Yes" : "No"}
          </p>
        </td>

        <td className="text-center d-flex gap-3 align-items-center">
          {" "}
          <span>
            {" "}
            <CalendarTodayOutlined fontSize="small" />{" "}
          </span>{" "}
          <p>
            {" "}
            {`${moment(permit?.startDate)?.format("MM/DD/YYYY")} - ${moment(
              permit?.endDate
            )?.format("MM/DD/YYYY")}`}
          </p>
        </td>

        <td className="text-center">{permit?.description}</td>
      </>
    );
  };

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <Topbar />
        <Sidebar />
        <section className="bg-white page-header position-relative w-100 page-header-2">
          <div className="page-wrapper">
            <div className="d-flex w-100  m-0 p-0 align-items-center justify-content-between gap-5">
              <div className="">
                <h4 className="page-title page-title-alt fw-bold">Holidays</h4>
                <p className="page-paragraph">Company Holidays</p>
              </div>
            </div>
          </div>
        </section>
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Search Filter -->*/}
            <div className="grid-cat-1 filter-row">
              <div className="">
                <div className="form-group form-focus text-gray-400 d-flex align-items-center justify-content-between">
                  <select
                    className="form-control floating"
                    value={theQueryParams.status}
                    name="status"
                    onChange={(e) => onChangeInput(e)}
                  >
                    <option selected value="">
                      Select Status
                    </option>
                    {openDetails?.uniqueStatus?.map((name) => (
                      <option value={name}>{name}</option>
                    ))}
                  </select>
                  <div className=" pr-2">
                    <DownArrowIcon color="#6c757d" />
                  </div>
                </div>
              </div>

              <div className="search-date cal-icon">
                <RsDateRangePicker
                  placement="bottomEnd"
                  onClean={(event, picker) => clearDateRange(event, picker)}
                  onOk={(event, picker) => filterByDateRange(event, picker)}
                  placeholder="Select From and To Date"
                />
              </div>
            </div>
            {/*<!-- /Search Filter -->*/}

            <div className="my-4">
              <div className="d-flex align-items-center">
                <div
                  className={`mx-2 p-cursor ${
                    changeView === "table"
                      ? "blue-color text-primary-main"
                      : "text-ash-main"
                  }`}
                  onClick={() => setChangeView("table")}
                >
                  <ListIcon color={changeView === "table" ? "#2463ae" : null} />{" "}
                  <b>List View</b>
                </div>

                <div
                  className={`mx-2 p-cursor ${
                    changeView === "table"
                      ? "text-ash-main"
                      : "blue-color text-primary-main"
                  }`}
                  onClick={() => setChangeView("calendar")}
                >
                  <GridIcon color={changeView === "table" ? null : "#2463ae"} />{" "}
                  <b>Calender View</b>
                </div>
              </div>
            </div>

            {allPermission.length > 0 ? (
              <>
                {changeView === "table" ? (
                  <TableComponent
                    responsive
                    striped
                    sticky
                    tableHeadsFunction={permissionTableHead}
                    mainDataArray={allPermission}
                    tableDataRowFunction={permissionTableBodyData}
                    className="product-table text-nowrap"
                  />
                ) : (
                  <CalendarView data={allPermission} />
                )}
              </>
            ) : (
              <NoTableItem />
            )}
          </div>
          {/*<!-- /Page Content -->*/}

          <div className="my-4">
            <CustomPagination
              setQueryParams={setQueryParams}
              startIndex={returnParams.startIndex}
              endIndex={returnParams.endIndex}
              count={returnParams.count}
              limit={queryParams.limit}
              page={queryParams.page}
              dropDownFunction={dropDownFunction}
            />
          </div>
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
      <ModalLoader show={loading} />
    </body>
  );
};

export default Holidays;
